.content {
  display: flex;
  align-items: center;
}
.content-left {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-left: 0.5rem;
  padding-right: 0.75rem;
}
.success {
  background-color: #5cb85c;
}
.warning {
  background-color: #ffc107;
}
.danger {
  background-color: #d9534f;
}
.content-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  svg {
    height: auto;
    width: 20px;

    path {
      fill: white;
    }
  }
}

.icon-close {
  cursor: pointer;
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  padding: 0;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  display: flex;
  align-items: center;
  margin: 0 0.5rem;
  width: 12px;
}

.content-right {
  display: block;
  overflow: hidden;
  width: 100%;
}

.content-heading {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

.content-heading-title {
  margin: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-size: 1.25rem;
}
